import mapStyles from '../data/map-styles.json';

/**
 * Registry of available map styles.
 * Flattened from map-styles.json for single-mode selection.
 */
export class MapStyle {
    static get ALL() {
        return [
            ...mapStyles.light.map(s => ({ ...s, group: 'Light', url: s.mapbox_url || s.id })),
            ...mapStyles.dark.map(s => ({ ...s, group: 'Dark', url: s.mapbox_url || s.id }))
        ];
    }

    static getDefault() {
        // Default to a solid Mono Light style (typically index 0 or defined)
        // Adjust logic if specific default needed
        return this.ALL.find(s => s.label === 'Mono') || this.ALL[0];
    }

    static findByUrl(url) {
        return this.ALL.find(s => s.url === url);
    }
}
